"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useButton", {
  enumerable: true,
  get: function () {
    return _useButton.useButton;
  }
});
var _useButton = require("./useButton");